module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image",
    style: (("background-image: url(" + _vm.image + ");"))
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57c735ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AsideImage.vue
// module id = 128
// module chunks = 0